import { HistoryEditor } from 'slate-history';
import { Transforms } from 'slate';
import * as serializer from 'basic-editor-value-serializer';

export function cloneProperties(node) {
  if (node.properties && node.properties.icon != null) {
    return { ...node, properties: { ...node.properties, icon: { ...node.properties.icon } } };
  }
  return { ...node };
}

export function duplicate(editor, node, path) {
  HistoryEditor.withNewBatch(editor, function duplicateIcon() {
    Transforms.insertNodes(editor, serializer.utilities.node.icon.cloneNode(node), { at: path });
  });
}
